import api from "../utils/api";
import { LOGOUT } from "./types";

export const get = ({authentic=false, name, category}) => async (dispatch) => {
    try {
        const pivot = (authentic ? "p/" : "") + (name ? "n" : "c");
        const res = await api.get(`/settings/${pivot}/${name ?? category}`);
        return res.data;
    } catch (err) {
        dispatch({
            type: LOGOUT
        });
    }
}

export const save = ({ uuid, name, category, value, description, visibility, priority }) => async (dispatch) => {
    try {
        const obj = { uuid, name, category, value, description, visibility, priority };
        const cleaned = Object.fromEntries(
            Object.entries(obj).filter(([_, v]) => v != null)
        );
        const res = await api.post(`/settings`, cleaned);
        return res.data;
    } catch (err) {
        dispatch({
            type: LOGOUT
        });
    }

}